import { render, staticRenderFns } from "./Yonetim.vue?vue&type=template&id=18f2de64&scoped=true&"
import script from "./Yonetim.vue?vue&type=script&lang=js&"
export * from "./Yonetim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2de64",
  null
  
)

export default component.exports